/**
 * Enregistrement du service worker.
 *
 * Uniquement en production : en développement, un worker qui met en cache la
 * coque masque les modifications et fait perdre un temps considérable.
 *
 * La version est injectée à la compilation et transmise en paramètre d'URL, ce
 * qui suffit à déclencher la réinstallation du worker à chaque publication.
 */

/** Signalé quand une nouvelle version est installée et attend d'être activée. */
export type UpdateListener = (activate: () => void) => void;

export function registerServiceWorker(onUpdateReady?: UpdateListener): void {
  if (!import.meta.env.PROD) return;
  if (!("serviceWorker" in navigator)) return;

  let updateRequested = false;
  let hasReloaded = false;

  window.addEventListener("load", () => {
    void navigator.serviceWorker
      .register(`/sw.js?v=${__APP_VERSION__}`, { scope: "/" })
      .then((registration) => {
        registration.addEventListener("updatefound", () => {
          const installing = registration.installing;
          if (!installing) return;

          installing.addEventListener("statechange", () => {
            const isWaitingUpdate =
              installing.state === "installed" && navigator.serviceWorker.controller !== null;
            if (!isWaitingUpdate) return;

            onUpdateReady?.(() => {
              updateRequested = true;
              registration.waiting?.postMessage("skip-waiting");
            });
          });
        });
      })
      .catch((error: unknown) => {
        // L'échec d'enregistrement ne doit jamais empêcher l'album de fonctionner.
        console.warn("[album] service worker non enregistré", error);
      });
  });

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    // Ne recharge que si la mise à jour a été demandée explicitement. Sans ce
    // garde-fou, la toute première visite rechargerait la page dès que le
    // worker prend la main via `clients.claim()`.
    if (!updateRequested || hasReloaded) return;
    hasReloaded = true;
    window.location.reload();
  });
}
